module.exports = __webpack_public_path__ + "static/media/1 18 kjerring.5233ef0b.mp3";